// Kommentarhistorie der Meldungen (Bauplan Punkt 7: "Kommentarhistorie im Verlauf-Bereich").
// Ergaenzende Information neben dem Melden-Button — faellt bei Backend-Fehler still auf "keine
// Historie" zurueck (analog zum bestehenden getCompare-Fehlerpfad in AbDocumentDetail), damit ein
// noch fehlender Endpunkt (BE-1) die Detailansicht nicht blockiert.

import React, { useEffect, useState } from 'react';
import { Flag, CheckCircle2, MessageSquare } from 'lucide-react';
import { Card, SectionTitle, fmtDate } from '../ui';
import { getReportComments } from '../../api';

const AbReportHistory = ({ user, isDarkMode, t, documentId }) => {
  const [comments, setComments] = useState([]);

  useEffect(() => {
    let alive = true;
    if (!documentId) { setComments([]); return undefined; }
    getReportComments(user, documentId)
      .then((cs) => { if (alive) setComments(Array.isArray(cs) ? cs : []); })
      .catch(() => { if (alive) setComments([]); });
    return () => { alive = false; };
  }, [user, documentId]);

  if (comments.length === 0) return null;

  return (
    <Card isDarkMode={isDarkMode}>
      <SectionTitle isDarkMode={isDarkMode}>
        <span className="flex items-center gap-2"><MessageSquare className="w-4 h-4" />{t('abPdf.reportHistoryTitle')}</span>
      </SectionTitle>
      <div className="space-y-0">
        {comments.map((c, i) => (
          <div key={i} className={`flex gap-3 py-2 border-b last:border-0 ${isDarkMode ? 'border-white/[0.08]' : 'border-slate-100'}`}>
            {c.kind === 'resolve'
              ? <CheckCircle2 className={`w-4 h-4 flex-shrink-0 mt-0.5 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`} />
              : <Flag className={`w-4 h-4 flex-shrink-0 mt-0.5 ${isDarkMode ? 'text-red-400' : 'text-red-600'}`} />}
            <div className="min-w-0">
              <div className={`text-sm ${isDarkMode ? 'text-white/80' : 'text-slate-700'}`}>{c.comment}</div>
              <div className={`text-[11px] ${isDarkMode ? 'text-white/40' : 'text-slate-400'}`}>
                {fmtDate(c.createdAt)}{c.author ? ` · ${c.author}` : ''} · {c.kind === 'resolve' ? t('abPdf.reportHistoryResolved') : t('abPdf.reportHistoryReported')}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default AbReportHistory;
